import React from 'react';
import { motion } from 'framer-motion';
import { Users, ShieldCheck, Building2, ArrowRight, Stethoscope } from 'lucide-react';
const portalCards = [
    {
        id: 'paciente',
        title: 'Portal do Paciente',
        description: 'Acompanhe prescrições, compras e benefícios com uma experiência personalizada.',
        highlights: [
            'Catálogo completo de produtos com recomendações',
            'Histórico de pedidos e status de entrega',
            'Cupons exclusivos e suporte dedicado',
        ],
        icon: <Users className="w-10 h-10"/>,
        accent: {
            base: 'from-emerald-600/10 to-teal-500/10',
            highlight: 'text-emerald-700',
            text: 'text-emerald-800',
        },
    },
    {
        id: 'backoffice',
        title: 'Backoffice GreenClub',
        description: 'Ambiente estratégico para administradores, representantes e clínicas.',
        highlights: [
            'Painéis em tempo real e inteligência de vendas',
            'Gestão de cadastros e aprovações',
            'Controle de comissões e configurações avançadas',
        ],
        icon: (<div className="flex gap-2">
        <ShieldCheck className="w-8 h-8"/>
        <Stethoscope className="w-8 h-8"/>
        <Building2 className="w-8 h-8"/>
      </div>),
        accent: {
            base: 'from-slate-800/10 via-slate-700/10 to-emerald-700/10',
            highlight: 'text-slate-800',
            text: 'text-slate-900',
        },
    },
];
const PortalSelector = ({ onSelectPortal }) => {
    return (<div className="min-h-screen bg-gradient-to-br from-stone-100 via-white to-emerald-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-6xl">
        <div className="text-center mb-12">
          <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-4xl md:text-5xl font-bold text-slate-900">
            Bem-vindo ao <span className="text-emerald-700">GreenClub</span>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} className="mt-3 text-base md:text-lg text-slate-600 max-w-2xl mx-auto">
            Escolha o ambiente ideal para a sua jornada. O GreenClub oferece experiências otimizadas
            para pacientes e para o time estratégico da plataforma.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {portalCards.map((card, index) => (<motion.button key={card.id} type="button" onClick={() => onSelectPortal(card.id)} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: index * 0.1 }} className="group relative w-full overflow-hidden rounded-3xl border border-slate-200 bg-white text-left shadow-sm focus:outline-none focus:ring-4 focus:ring-emerald-200">
              <div className={`absolute inset-0 bg-gradient-to-br ${card.accent.base} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}/>
              <div className="relative h-full px-8 py-10 flex flex-col gap-6">
                <div className="flex items-center justify-between">
                  <div className={`font-semibold uppercase tracking-wide text-xs ${card.accent.highlight}`}>
                    {card.id === 'paciente' ? 'Experiência Humanizada' : 'Inteligência de Gestão'}
                  </div>
                  <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} className={`${card.accent.text} drop-shadow-sm`}>
                    {card.icon}
                  </motion.div>
                </div>

                <div>
                  <h2 className={`text-2xl font-bold mb-2 ${card.accent.text}`}>{card.title}</h2>
                  <p className="text-slate-600 text-sm leading-relaxed">{card.description}</p>
                </div>

                <ul className="space-y-3">
                  {card.highlights.map((highlight) => (<li key={highlight} className="flex items-start gap-3 text-sm text-slate-700">
                      <span className="mt-1 inline-flex h-2 w-2 rounded-full bg-emerald-500"/>
                      <span>{highlight}</span>
                    </li>))}
                </ul>

                <div className="flex items-center justify-between pt-4 mt-auto border-t border-slate-100">
                  <div className="text-sm font-medium text-emerald-700 group-hover:text-emerald-800 transition-colors">
                    Acessar este portal
                  </div>
                  <motion.div initial={{ x: 0 }} animate={{ x: 0 }} whileHover={{ x: 4 }} className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                    <ArrowRight className="w-5 h-5"/>
                  </motion.div>
                </div>
              </div>
            </motion.button>))}
        </div>
      </div>
    </div>) ;
};
export default PortalSelector;
